import { createApiBuilder } from 'haper';
import { haper } from '../../shared/haper';

export const getFakerSwitch = ():boolean => localStorage.getItem('haper_faker') === 'true';
export const setFakerSwitch = (val: boolean) => localStorage.setItem('haper_faker', JSON.stringify(val));

export const API = createApiBuilder(haper, {
    faker: process.env.NODE_ENV === 'development' ? getFakerSwitch() : false
});

export interface ExpertRegistrationFormId {
    expertRegistrationFormId?: string
}

export interface ApiListResponse<T> {
    hasNext: boolean
    hasPrevious: boolean
    items: T[]
    pageNumber: number
    pageSize: number
    totalCount: number
    totalPages: number
}

export interface ApiListResponseWithFormId<T> extends ApiListResponse<T> {
    expertRegistrationFormId: string
}

export interface ApiPaginationParams {
    'paginationParameters.pageSize'?: number
    'paginationParameters.pageNumber'?: number
    'paginationParameters.orderByColumn'?: string|null|undefined
    'paginationParameters.sortBy'?: string
}

export interface PaginationParams {
    pageSize?: number
    pageNumber?: number
    sortColumn?: string|null|undefined
    sortMode?: 'ASC' | 'DESC' | undefined
}

export function parseToDotnetPaginationNamespace<T extends PaginationParams>({ pageNumber, sortColumn, pageSize, sortMode, ...rest }: T): ApiPaginationParams&Omit<T, keyof PaginationParams> {
    return {
        ...pageSize && {'paginationParameters.pageSize': pageSize},
        ...pageNumber && {'paginationParameters.pageNumber': pageNumber},
        ...sortColumn && {'paginationParameters.orderByColumn': sortColumn},
        ...sortMode && {'paginationParameters.sortBy': sortMode},
        ...rest
    };
}

